import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import authenticationService from 'services/AuthenticationService';
import { useAppMode } from 'contexts/AppModeContext';
import AuthenticationPage from 'pages/AuthenticationPage';

const PrivateRoute = () => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null);
  const { isEmbedded, isTokenReady, error } = useAppMode();

  useEffect(() => {
    // Use unified authentication service
    authenticationService
      .validateUser(true)
      .then(result => {
        setIsUserAuthenticated(result.isValidUser);
      })
      .catch(() => {
        setIsUserAuthenticated(false);
      });
  }, [isTokenReady]);

  // In embedded mode, show loading while waiting for token
  if (isEmbedded && isUserAuthenticated === null && !isTokenReady) {
    return <AuthenticationPage />;
  }

  if (isUserAuthenticated === true) return <Outlet />;

  if (isUserAuthenticated === false) {
    // In embedded mode, don't redirect to login, just show error
    if (isEmbedded) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>Authentication required. Please provide a valid token from the parent portal.</p>
          {error && <p style={{ color: 'red' }}>Error: {error}</p>}
        </div>
      );
    }
    return <Navigate to="/login" />;
  }

  return <AuthenticationPage />;
};

export default PrivateRoute;
